module.exports = __webpack_public_path__ + "img/grade-teacher.2d5695f5.png";